import { render } from "./NotFoundPage.vue?vue&type=template&id=17287fe5&scoped=true"
const script = {}

import "../styles/notFoundPage.css?vue&type=style&index=0&id=17287fe5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17287fe5"]])

export default __exports__